module.exports = __webpack_public_path__ + "static/media/img3@3x.014e2ac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img3@3x.jpg
// module id = 1783
// module chunks = 0 1